export default __webpack_public_path__ + "static/instagram-884739110fd4affb5272418d0e09b98b.png";